class GetRolePermissionAffiliation {
  constructor() {
    this.rolePermissionAffiliation = [];
  }

  getRolePermissionAffiliationResp(iIndex) {
    return this.rolePermissionAffiliation[iIndex];
  }

  setRolePermissionAffiliationResp(iIndex, rolePermissionAffiliation) {
    this.rolePermissionAffiliation[iIndex] = rolePermissionAffiliation;
  }

  resetRolePermissionAffiliation() {
    this.rolePermissionAffiliation = [];
  }
}

export default new GetRolePermissionAffiliation();
